import { MouseEvent } from 'react';
import styles from './index.module.scss';

export const IconButton = ({
  Icon,
  onClick,
  href,
}: {
  Icon: React.ComponentType<{ size: 'S'; color: 'blue' | 'gray' }>;
  onClick?: React.MouseEventHandler<HTMLAnchorElement>;
  href?: string;
}) => {
  const onClickAnchor = (event: MouseEvent<HTMLAnchorElement>) => {
    if (!onClick) return;
    onClick(event);
  };

  if (!href)
    return (
      <span
        className={`${styles.iconButton} ${styles['iconButton--disabled']}`}
      >
        <Icon size="S" color="gray" />
      </span>
    );

  return (
    <a className={styles.iconButton} onClick={onClickAnchor} href={href}>
      <Icon size="S" color="blue" />
    </a>
  );
};
